// extracted by mini-css-extract-plugin
export default {"AddButton":"AcademyEducationList_AddButton__u10A5","Card":"AcademyEducationList_Card__HRAep","Table":"AcademyEducationList_Table__Y50fB","Paper":"AcademyEducationList_Paper__JZNGn"};